import {faCogs} from "@fortawesome/pro-solid-svg-icons/faCogs";
import {faFolder} from "@fortawesome/pro-solid-svg-icons/faFolder";
import {faInfoCircle} from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import {faScaleBalanced} from "@fortawesome/pro-solid-svg-icons/faScaleBalanced";
import {faStars} from "@fortawesome/pro-solid-svg-icons/faStars";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTour} from "@reactour/tour";
import {
    Button,
    ButtonSize,
    ColourSolid,
    ColourOutline,
    Directions,
    Drawer,
    FlexGap,
    StackVertical, Tooltip,
    useOutsiderDetector
} from "@twigsby/frontend-framework";
import React, {useRef, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {useNavigate} from "react-router-dom";

const MailboxInfo = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { setIsOpen } = useTour();

    const [showInfo, setShowInfo] = useState<boolean>(false);

    const mailInfoRef = useRef<HTMLDivElement>(null);

    useOutsiderDetector(mailInfoRef, () => setShowInfo(false));

    return (
        <>
            <Tooltip content={t('mailboxes.infoDrawer.title')}>
                <Button title={t("mailboxes.infoDrawer.title")} iconOnly={true} squared={true} icon={faInfoCircle} colour={ColourSolid.Secondary} onClick={() => setShowInfo(true)} />
            </Tooltip>

            <Drawer title={t("mailboxes.infoDrawer.title")} isOpen={showInfo} direction={Directions.End} closeCallback={() => setShowInfo(false)}>

                <StackVertical gap={FlexGap.ExtraLarge}>

                    <StackVertical>
                        <div className={'h6 mb-xs'}>
                            <FontAwesomeIcon icon={faCogs} fixedWidth={true} /> Mail Settings
                        </div>
                        <p>You can change your mail settings to automatically open and scan received mail, forward scanned mail to your e-mail, set the default number of pages scanned, as well as many other options.</p>
                        <Button title={'Show Me'} size={ButtonSize.Small} alignLeft={true} colour={ColourOutline.Primary} />
                    </StackVertical>

                    <StackVertical>
                        <div className={'h6 mb-xs'}>
                            <FontAwesomeIcon icon={faFolder} fixedWidth={true} /> Custom Mail Folders
                        </div>
                        <p>Create custom folders to further categorise and organise your mail items.</p>
                        <Button title={'Show Me'} size={ButtonSize.Small} alignLeft={true} colour={ColourOutline.Primary} />
                    </StackVertical>

                    <StackVertical>
                        <div className={'h6 mb-xs'}>
                            <FontAwesomeIcon icon={faScaleBalanced} fixedWidth={true} /> Custom Rule-sets
                        </div>
                        <p>Create rule-sets for your mail items that allow you to automatically action, forward, and organise your mail items.</p>
                        <Button title={'Show Me'} size={ButtonSize.Small} alignLeft={true} colour={ColourOutline.Primary} onClick={() => navigate('/manage-account/rulesets')} />
                    </StackVertical>

                    <Button icon={faStars} onClick={() => {
                        setShowInfo(false);
                        setIsOpen(true);
                    }} title={t("mailboxes.actions.startTour")} squared={true} />

                </StackVertical>

            </Drawer>

        </>
    )

}

export { MailboxInfo }
